import { mString } from 'lib/helpers/utility';

import DrAvatar from './lib/components/DrAvatar';
import SlideHeader from './lib/components/SlideHeader';
import SpeechBubble from './lib/components/SpeechBubble';

const MaximumCheckPage = ({ estimate }) => {
  const isDental = estimate?.vertical === 'dental';

  const max = estimate?.benefitSummary?.outOfPocket?.annual ?? null;
  const oopRemaining = estimate?.benefitSummary?.outOfPocket?.remaining ?? null;
  const used = max != null && oopRemaining != null ? Math.max(0, max - oopRemaining) : null;
  const hasOopFigures = max != null && used != null;

  const annualMaxRemaining = estimate?.annualMaxRemaining ?? null;

  return (
    <div className="flex flex-col gap-5">
      <SlideHeader title="Coverage" />

      <div className="flex items-start gap-4 sm:flex-col">
        <DrAvatar size="medium" variant={4} />
        <div className="flex-1 rounded-xl bg-gradient-to-r from-[#0093C4] to-[#00B8E8] p-4 text-white">
          <p className="text-lg font-700">More good news</p>
          <p className="text-sm font-400 opacity-80">your insurance still has room to help</p>
        </div>
      </div>

      {isDental ? (
        <SpeechBubble variant="default">
          Your plan has a <span className="font-600 italic">yearly maximum</span> — the most it will
          pay for covered dental care this year.
          {annualMaxRemaining != null
            ? ` You have ${mString(annualMaxRemaining)} of that left,`
            : ' You still have room left,'}{' '}
          so your insurance will help cover today's visit.
        </SpeechBubble>
      ) : (
        <SpeechBubble variant="default">
          You haven't hit your <span className="font-600 italic">out-of-pocket maximum</span> yet —
          that's the cap on what you'll pay out of pocket for the year.
          {hasOopFigures
            ? ` Your plan caps your costs at ${mString(max)}, and you've used ${mString(
                used
              )} so far.`
            : ''}{' '}
          You have plenty of room left, so your insurance will help cover today's visit.
        </SpeechBubble>
      )}
    </div>
  );
};

export default MaximumCheckPage;
